import { ActionContext } from 'vuex';

const _state: {
	meta: {
		title?: string;
		description?: string;

		ogTitle?: string;
		ogDescription?: string;
		ogImage?: string;
	};
} = {
	meta: {
		title: undefined,
		description: undefined,

		ogTitle: undefined,
		ogDescription: undefined,
		ogImage: undefined,
	},
};

type State = typeof _state;
type Meta = 'title' | 'description' | 'ogTitle' | 'ogDescription' | 'ogImage';



export const MetaModule = {
	namespaced: true,

	state: _state,

	getters: {
		GET_META: (state: any) => {
			return state.meta;
		},
	},

	actions: {
		CHANGE_META: (context: ActionContext<State, State>, payload: [Meta, string?]) => {
			context.commit('SET_META', payload);
		},

		RESET_META: (context: ActionContext<State, State>) => {
			context.commit('SET_META', undefined);
		},
	},

	mutations: {
		SET_META: (state: State, payload?: [Meta, string?]) => {
			if (payload === undefined) {
				for (const key in state.meta) {
					state.meta[key as Meta] = undefined;
				}
			} else {
				state.meta[payload[0]] = payload[1];
			}
		},
	},
};
